"use strict";

define('evisions/helper/defer',['underscore'], function (_) {
  var EVIHelperDefer = _.extend({
    defer: function defer() {
      return _.defer.apply(_, arguments);
    },
    resolveAfter: function resolveAfter(deferred, count) {
      var extraArgs = $.makeArray(arguments).slice(2),
        current = 0,
        resolver = null;
      resolver = function resolver() {
        current++;
        if (current === count) {
          deferred.resolve.apply(deferred, extraArgs);
        }
      };
      return resolver;
    }
  });
  return EVIHelperDefer;
});

